export const HOME = 'homeInsure';
export const LIFE = 'life';
export const PET = 'pet';
export const AUTO_SAVING = 'autoSavings';
